// extracted by mini-css-extract-plugin
module.exports = {"info":"info_info__rQiOK","title":"info_title__vsvEd","hr":"info_hr__1w1tE"};